import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash/fp';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Slugify, SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import RouteCollection from '@bd/bdcore-named-routes';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuVideoCategories from './MenuVideoCategories';
// import { colors } from '../../styles';

const styles = css`
  .VideoGallery_List {
    padding:3px;
  }
  .PhotoCard {
    width:100%;
    position: relative;
    padding:0;
    padding-top:56%;
    background-size: cover;
    background-position: center;
    border:3px solid white;
  }
  .PlayIcon {
    position:absolute;
    top:50%;
    margin-top:-30px;
    left:50%;
    margin-left:-30px;
    width:60px;
    height:60px;
    border-radius: 50%;
    border:4px solid white;
    text-align: center;
    display: flex;
    flex-flow:column wrap;
    justify-content: center;
    background:rgba(0,0,0,.4);
    .PlayIcon_triangle {
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid white;
      margin: 0 auto;
    }
  }

  .PhotoList_content {
    display:none;
    position: absolute;
    bottom:0;
    right:0;
    left:0;
    padding:15px;
    transition: all .25s ease;
    opacity: 1;
    background:rgba(34,34,34,.7);
    color:white;
    @media (min-width: 991px) {
      opacity:0;
    }
    .PhotoList_contentHeading {
      display: flex;
      h4 {
        color:white;
        text-transform: capitalize;
        font-weight:700;
        margin:0;
        line-height: 1;
        font-size: 20px;

        @media (min-width: 991px) {
          font-size:24px;
          line-height: 1;
        }
      }
    }
    .PhotoList_statsList {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        margin-right:10px;
        .hotoList_iconListIcon {
          margin: 0 0 4px 0;
        }
        .hotoList_iconListValue {
          font-weight: 700;
        }
      }
    }
  }
  .VideoList_Item:hover .PhotoList_content {
    opacity: 1;
  }
`;

// const videoBoxStyle = css`
//   position: relative;
//   width: 80%;
//   padding-top: calc(80% * 0.5625);
//   margin-top: -22%;
//   top: 50%;
//   margin-left: 10%;
//   iframe {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//   }
// `;

const videoBoxStyle = css`
position: relative;
width: 80%;
padding-top: calc(80% * 0.5625);
margin-top: -22%;
top: 50%;
margin-left: 10%;

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
`;

class VideoGallery extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeVideo: null,
    };
  }

  setVideoRef = ref => {
    this.videoRef = ref;
  }

  render() {
    const { page, router } = this.props;
    let { activeVideo } = this.state;

    const route = RouteCollection.getRouteByPath(_.get('location.pathname', router));
    const gallerySlug = _.get('params.gallery', route);
    let activeGallery;
    let videos = [];

    if (gallerySlug) {
      activeGallery = _.getOr([], 'video_galleries', page)
        .find(g => Slugify(_.getOr('', 'gallery_title', g)) === gallerySlug);
      videos = _.getOr([], 'videos', activeGallery);
    } else {
      videos = _.flow(
        _.map('videos'),
        _.flatten,
      )(_.getOr([], 'video_galleries', page));
    }

    if (!activeVideo) {
      [activeVideo] = videos;
    }

    return (
      <PageWrapper className={styles}>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuVideoCategories
          page={page}
        />
        <LightBox
          onlyWithIndex
          items={videos.map(video => ({
            element: (
              <div
                className={videoBoxStyle}
                dangerouslySetInnerHTML={SanitizeHtml(video.video)}
              />
            ),
          }))}
        >
          <ul className="VideoGallery_List list-unstyled row m-0 justify-content-center">
            {
              videos.map((video, i) => (
                <li className="col-12 col-sm-6 p-0 col-xl-4 VideoList_Item" key={_.get('title', video)}>
                  {/* <YoutubeThumbnail
                    video={_.get('video', video)}
                    index={i}
                  /> */}
                  {/* <img src={_.get('thumbnail_preview.contentUrl', video)} alt="" /> */}
                  {/* <img src={buildThumbnailUrl(get(video, 'thumbnail_preview.contentUrl')
                  , { height: 450, width: 800, exact: true })} data-index={i} alt="" /> */}
                  <div className="PhotoCard" data-index={i} style={{ backgroundImage: `url(${buildThumbnailUrl(get(video, 'thumbnail_preview.contentUrl'), { width: 800, height: 450, exact: true })})` }} />
                  {/* <div className="Favorite-circle">
                    <FavoriteToggle
                      content={{
                        name: 'Video',
                        _id: video.video,
                        iframe: true,
                        imageUrl: get(video, 'thumbnail_preview.contentUrl'),
                      }}
                    />
                  </div> */}
                  <div className="PlayIcon" data-index={i}>
                    <div className="PlayIcon_triangle" data-index={i} />
                  </div>
                  <div className="PhotoList_content">
                    <div className="PhotoList_contentHeading">
                      <h4>{get(video, 'title')}</h4>
                    </div>
                  </div>
                </li>
              ))
            }
          </ul>
        </LightBox>
      </PageWrapper>
    );
  }
}

VideoGallery.propTypes = {
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData({
  page: 'video_gallery',
  router: true,
})(VideoGallery);



// WEBPACK FOOTER //
// ./src/pages/VideoGallery/index.js